import { useState } from "react";
import "../Components/CSS/Global.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function BookSchedule({ isVisible, onClose }) {
    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        email: "",
        date: "",
        time: "",
        meetingType: "call",
        address: "",
        clientAddress: "",
        dob: "Website"
    });
    const [loading, setLoading] = useState(false);
    const [timeError, setTimeError] = useState("");
    const [isHumanChecked, setIsHumanChecked] = useState(false);
    const [agreedToTerms, setAgreedToTerms] = useState(false);
    const [checkboxErrors, setCheckboxErrors] = useState({
        isHuman: false,
        terms: false,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "time") {
            if (value < "11:00" || value > "17:00") {
                setTimeError("Select a time from 11 AM to 5 PM");
                return;
            } else {
                setTimeError(""); // Clear error when valid
            }
        }

        setFormData({ ...formData, [name]: value });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isHumanChecked || !agreedToTerms) {
            setCheckboxErrors({
                isHuman: !isHumanChecked,
                terms: !agreedToTerms,
            });
            return;
        }
        setLoading(true);

        try {
            const response = await fetch("https://100billionrealestate.com/book-appointment", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {

                toast.success("Thank you! Your appointment has been scheduled.", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });
                onClose(); // Optionally close the modal
                setFormData({
                    name: "",
                    phone: "",
                    email: "",
                    date: "",
                    time: "",
                    meetingType: "call",
                    address: "",
                    clientAddress: "",
                    dob: "Website"
                });
                setIsHumanChecked(false)
                setAgreedToTerms(false)
            } else {
                toast.error("Please try again!", {
                    position: "top-center",
                    autoClose: 10000, // Close toast after 3 seconds
                });
            }
        } catch (error) {
            toast.error(`${error}`, {
                position: "top-center",
                autoClose: 10000, // Close toast after 3 seconds
            });
        } finally {
            setLoading(false); // Stop loader after request completion
        }
    };


    const getMinDate = () => {
        let today = new Date();
        today.setDate(today.getDate() + 2); // Skip today and tomorrow
        return today.toISOString().split("T")[0];
    };

    if (!isVisible) return null;

    return (
        <div className="popup-form-hbt">
            <div className="popup-content-hbt">
                <div className="popup-header-hbt">
                    <div className="popup-header-close-hbt" onClick={onClose}>
                        <i className="fa-solid fa-xmark desktop-close-hbt"></i>
                        <i className="fa-solid fa-arrow-left mobile-close-hbt"></i>
                    </div>
                    <h3>Book free consultation</h3>
                    <div></div>
                </div>
                <form onSubmit={handleSubmit} className="bs-form-hbt">
                    <div className="bs-group-hbt">
                        <label>Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Enter your full name"
                        />
                    </div>

                    <div className="bs-group-hbt">
                        <label>Phone Number</label>
                        <input
                            type="number"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            required
                            placeholder="Enter your phone number"
                        />
                    </div>

                    <div className="bs-group-hbt">
                        <label>Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email address"
                        />
                    </div>
                    <div className="bs-group-hbt">
                        {/* <label>Schedule date & time</label> */}
                        <div className="book-date-time-hbt">
                            <div>
                                <label>Schedule date</label>
                                <input
                                    type="date"
                                    name="date"
                                    value={formData.date}
                                    onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                                    required
                                    min={getMinDate()}
                                    className="bs-custom-input"
                                    autoFocus
                                />
                            </div>
                            <div>
                                <label>Time</label>
                                <input
                                    type="time"
                                    name="time"
                                    value={formData.time}
                                    onChange={handleChange}
                                    required
                                    min="11:00"
                                    max="17:00"
                                    className="bs-custom-input"
                                />
                                {timeError && <p className="error-message-form">{timeError}</p>}
                            </div>

                        </div>
                    </div>

                    <div className="bs-group-hbt">
                        <label>Meeting Type</label>
                        <div className="bs-radio-group-hbt">
                            <input type="radio" id="call" name="meetingType" value="call"
                                checked={formData.meetingType === "call"}
                                onChange={handleChange}
                                className="bs-hidden-radio-hbt" />
                            <label htmlFor="call" className={formData.meetingType === "call" ? "active" : ""}>Call/ Online meet</label>

                            <input type="radio" id="meet" name="meetingType" value="meet"
                                checked={formData.meetingType === "meet"}
                                onChange={handleChange}
                                className="bs-hidden-radio-hbt" />
                            <label htmlFor="meet" className={formData.meetingType === "meet" ? "active" : ""}>In-person Meeting</label>
                        </div>
                    </div>

                    {formData.meetingType === "meet" && (
                        <div className="bs-group-hbt">
                            <label>Meeting Location</label>
                            <div className="bs-radio-group-hbt">
                                <input type="radio" id="client" name="address" value="client"
                                    checked={formData.address === "client"}
                                    onChange={handleChange}
                                    className="bs-hidden-radio-hbt" />
                                <label htmlFor="client" className={formData.address === "client" ? "active" : ""}>At Your Location</label>

                                <input type="radio" id="office" name="address" value="office"
                                    checked={formData.address === "office"}
                                    onChange={handleChange}
                                    className="bs-hidden-radio-hbt" />
                                <label htmlFor="office" className={formData.address === "office" ? "active" : ""}>At Our Office</label>
                            </div>

                            {formData.address === "client" && (
                                <input
                                    type="text"
                                    name="clientAddress"
                                    value={formData.clientAddress}
                                    placeholder="Enter your address"
                                    onChange={handleChange}
                                    className="bs-custom-input"
                                />

                            )}

                            {formData.address === "office" && (
                                <div className="our-address-hbt">
                                    <p>
                                        <strong>Our Office Address:</strong>
                                        <br />
                                        E-10 4th floor, Nemi Krishna Building, Jethwa Nagar Opposite Bajaj School, Kandivali West, 400067<br />
                                        <div className="our-office-map-hbt">
                                            <a href="https://maps.app.goo.gl/ctmvjkeTVRS8KDaJ8"><i className="fa-solid fa-paper-plane"></i> Get direction</a>
                                        </div>
                                    </p>
                                </div>
                            )}
                        </div>
                    )}
                    <div>
                        <div className="form-mainfieldcheck-hbt">
                            <div className="form-fieldcheck-hbt">
                                <input
                                    type="checkbox"
                                    id="isHuman"
                                    className="humanischecked-hbt"
                                    checked={isHumanChecked}
                                    onChange={(e) => {
                                        setIsHumanChecked(e.target.checked);
                                        setCheckboxErrors((prev) => ({ ...prev, isHuman: false }));
                                    }}
                                />

                                <p className="form-terms-hbt">Please check the box to confirm you're human</p>



                            </div>
                            {checkboxErrors.isHuman && <p className="error-message-form">Please confirm you're human</p>}
                            <div className="form-fieldcheck-hbt">
                                <input
                                    type="checkbox"
                                    id="terms"
                                    className="humanischecked-hbt"
                                    checked={agreedToTerms}
                                    onChange={(e) => {
                                        setAgreedToTerms(e.target.checked);
                                        setCheckboxErrors((prev) => ({ ...prev, terms: false }));
                                    }}
                                />
                                <p className="form-terms-hbt">By submitting, you agree to our <span onClick={() => window.open("https://100billiontech.com/terms-and-conditions", "_blank", "noopener,noreferrer")} style={{ cursor: "pointer", color: "#4685f6" }}>terms and conditions</span></p>


                            </div>
                            {checkboxErrors.terms && <p className="error-message-form">You must agree to the terms</p>}
                        </div>
                    </div>
                    <div className="form-actions-hbt">
                        <button type="submit" className="bs-submit-button" disabled={loading} >
                            {loading ? (
                                <div className="loader"></div> // Show loader while loading
                            ) : (
                                'Submit'
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
